import { render } from "./TaskEditor.vue?vue&type=template&id=1ac26336"
import script from "./TaskEditor.vue?vue&type=script&lang=js"
export * from "./TaskEditor.vue?vue&type=script&lang=js"

import "./TaskEditor.vue?vue&type=style&index=0&id=1ac26336&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__